import { LexbeCase } from '../case.model';
import { LifeCycle } from '../lifecycle.model';
import { User } from './user.model';

export class Account {
    accountId: string;
	accountName: string;
	accountComments: string;
	accountLogoFilename: string;
	message: string;
	crmUrl: string;
	type: string;
	lifeCycle: LifeCycle;
	docSize: number;
	indexSize: number;
	productionJobSize: number;
	downloadSize: number;
	archiveJobSize: number;
	isHibernated: boolean;
	users: User[];
	cases: LexbeCase[];
}
